import fetch from 'isomorphic-fetch';

export const fetchMaintenanceWindow = (maintenanceURL) => {

  const ONE_MINUTE = 60000;

  const requestBody = {
    'countryCode': 'MX',
    'groupMemberCode': 'HBMX',
    'journey': 'PREAPPROVED',
  };

  const maintenanceStatusURL = `${maintenanceURL}/maintenanceStatus`;

  return fetch(maintenanceStatusURL, {
    headers: { 'Content-Type': 'application/json' },
    timeout: ONE_MINUTE,
    method: 'POST',
    body: JSON.stringify(requestBody),
  })
    .then(res => {
      if (res.ok) {
        return res.json();
      } else {
        const processError = text => ({ error: true, message: `Server responded with ${res.status}`, debug: text });

        const contentType = res.headers.get('Content-Type');
        if (contentType && contentType.includes('json')) {
          return res.json().then(processError);
        } else {
          return res.text().then(processError);
        }
      }
    })
    .catch((e) => ({ error: true, debug: e }));
};
